<template>
  <div  class="content gimg" :style="styleObject" >
    </div>
</template>
<script>
export default {
  name: 'GFileImage',
  props: {
    gFile: Object,
    gBaseUrl: String
  },
  data () {
    return {
      styleObject: {
        paddingBottom: this.gFile.imageMediaMetadata.height / this.gFile.imageMediaMetadata.width * 100 + '%',
        background: ' white url(' + this.gBaseUrl + '/thumbnail?export=view&sz=w1140&id=' + this.gFile.id + ')',
        backgroundSize: 'cover'
      }

    }
  }
}
</script>
